export default {"src":"/_next/static/media/cryptocurrency-jobs.d67386ae.svg","height":700,"width":626,"blurWidth":0,"blurHeight":0};